<wl-content-section [id]="id()" [theme]="theme()">
  @if (title() && cards(); as cards) {
    <wl-product-card-section
      [title]="title()!"
      [content]="content()"
      [cards]="cards"
    />
  }
</wl-content-section>
